import type { Request } from "./request";
import type { RoutePathArguments } from "./route-path";


export interface Context<T extends RoutePathArguments = RoutePathArguments>
{
    request: Request<T>;
    parent?: Context;
}
